import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/** 数学运算 根据计算表达式进行数学运算
 * * * Math operators:
 * `['*', value1, value2]` multiplies `value1` by `value2`
 * `['/', value1, value2]` divides `value1` by `value2`
 * `['+', value1, value2]` adds `value1` and `value2`
 * `['-', value1, value2]` subtracts `value2` from `value1`
 * `['%', value1, value2]` returns the result of `value1 % value2` (modulo)
 * `['^', value1, value2]` returns the value of `value1` raised to the `value2` power
 * `['abs', value1]` returns the absolute value of `value1`
 * `['floor', value1]` returns the nearest integer less than or equal to `value1`
 * `['round', value1]` returns the nearest integer to `value1`
 * `['ceil', value1]` returns the nearest integer greater than or equal to `value1`
 * `['sin', value1]` returns the sine of `value1`
 * `['cos', value1]` returns the cosine of `value1`
 * `['atan', value1, value2]` returns `atan2(value1, value2)`. If `value2` is not provided, returns `atan(value1)`
 */
export function mathematical(symbol, n1, n2) {
  switch (symbol) {
    case '+':
      return n1 + n2;

    case '-':
      return n1 - n2;

    case '*':
      return n1 * n2;

    case '/':
      return n1 / n2;

    case '%':
      return n1 % n2;

    case '^':
      return Math.pow(n1, n2);

    case 'abs':
      return Math.abs(n1);

    case 'floor':
      return Math.floor(n1);

    case 'round':
      return Math.round(n1);

    case 'ceil':
      return Math.ceil(n1);

    case 'sin':
      return Math.sin(n1);

    case 'cos':
      return Math.cos(n1);

    case 'atan':
      return n2 === -1 ? Math.atan(n1) : Math.atan2(n1, n2);

    default:
      console.warn('Calculate symbol err! Return default 0');
      return 0;
  }
}
/**
 * 根据表达式计算
 * @param express 
 * @param bandsData 
 */

export function calculate(express, bandsData) {
  var _bandsData$ = bandsData[0],
      width = _bandsData$.width,
      height = _bandsData$.height;
  var dataArray = bandsData.map(function (band) {
    return band.rasterData;
  });
  var length = width * height;
  var rasterData = [];
  var originExp = JSON.stringify(express);

  for (var i = 0; i < length; i++) {
    var exp = JSON.parse(originExp); // 将表达式中的 ['band', 0]、['band', 1] 等替换为实际的栅格数据

    var expResult = spellExpress(exp, dataArray, i);

    if (typeof expResult === 'number') {
      // exp: ['band', 0] => exp: 2 ...
      // exp 直接指定了波段值，替换完后直接就是数值了，无需计算
      rasterData.push(expResult);
    } else {
      var result = calculateExpress(exp);
      rasterData.push(result);
    }
  }

  return rasterData;
}

/**
 * 将表达式中的指定波段替换为对应波段的栅格数据
 * @param express 
 * @param dataArray 
 * @param index 
 */
export function spellExpress(express, dataArray, index) {
  /**
   * 用户直接指定波段数值，无需计算
   */
  if (express.length === 2 && express[0] === 'band' && typeof express[1] === 'number') {
    try {
      return dataArray[express[1]][index];
    } catch (err) {
      console.warn('Raster Data err!');
      return 0;
    }
  }

  express.map(function (e, i) {
    if (Array.isArray(e) && e.length > 0) {
      switch (e[0]) {
        case 'band':
          try {
            express[i] = dataArray[e[1]][index];
          } catch (err) {
            console.warn('Raster Data err!');
            express[i] = 0;
          }

          break;

        default:
          spellExpress(e, dataArray, index);
      }
    }
  });
}
export function formatExpress(express) {
  var _express = _slicedToArray(express, 3),
      symbol1 = _express[0],
      _express$ = _express[1],
      symbol2 = _express$ === void 0 ? -1 : _express$,
      _express$2 = _express[2],
      symbol3 = _express$2 === void 0 ? -1 : _express$2;

  if (symbol1 === undefined) {
    console.warn('Express err!');
    return ['+', 0, 0];
  }

  var symbol = symbol1.replace(/\s+/g, '');
  return [symbol, symbol2, symbol3];
}
export function calculateExpress(express) {
  var formatExp = formatExpress(express);
  var str = formatExp[0];
  var left = formatExp[1];
  var right = formatExp[2];

  if (Array.isArray(left)) {
    left = calculateExpress(express[1]);
  }

  if (Array.isArray(right)) {
    right = calculateExpress(express[2]);
  }

  return mathematical(str, left, right);
}